<template>
	<div></div>
</template>

<script>
    export default {
        name: "index",
        data () {
            return {
                linkHtml: undefined
            }
        },
        mounted () {
            let html = this.$route.params.linkHtml;
			let index = html.indexOf(`"http`);
			let nextIndex = html.lastIndexOf(`";</scrip`);
			this.linkHtml = html.substring(index+1,nextIndex);
			window.location.href = this.linkHtml
        }
    }
</script>

<style scoped>

</style>
